var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"fill-height",attrs:{"width":"100vw","loading":_vm.loading}},[_c('v-card-text',{staticClass:"pt-0"},[_c('ShopStepper',{attrs:{"corporations":_vm.corporations},on:{"onSubmit":_vm.createShop},model:{value:(_vm.shop),callback:function ($$v) {_vm.shop=$$v},expression:"shop"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }